import { DialogWrapper } from 'components/dialogWrapper'
import { Loader } from 'components/loader'
import { Img } from 'components/image'
import { Dispatch, SetStateAction } from 'react'
import { useCategoryContent } from 'hooks/category-manage'

interface ViewCategoryDialogProps {
    isOpen: boolean
    setIsOpen: Dispatch<SetStateAction<boolean>>
    categoryData: any | null
}

const ViewCategoryDialog = ({
    isOpen,
    setIsOpen,
    categoryData,
}: ViewCategoryDialogProps) => {
    const { data: categoryContentData, isLoading } = useCategoryContent(categoryData?.id)
    if (!isOpen) return null
    const category = categoryContentData?.data?.category
    const collection = categoryContentData?.data?.collection || {}
    const episodes = categoryContentData?.data.episodes || []

    return (
        <DialogWrapper
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            title="Engagement Details"
        >
            <div className="space-y-4 p-2">
                {/* ===========================
          SHOW INFORMATION
      =========================== */}
                <div className="p-4 rounded-lg">
                    {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <p className="text-sm text-gray-500">{category?.numberOfViews?.label ?? '—'}</p>
                            <p className="font-medium">{category?.numberOfViews?.value ?? '—'}</p>
                        </div>

                        <div>
                            <p className="text-sm text-gray-500">{category?.numberOfEpisodesWatched?.label ?? '—'}</p>
                            <p className="font-medium">{category?.numberOfEpisodesWatched?.value ?? '—'}</p>
                        </div>
                        {/* <div>
                            <p className="text-sm text-gray-500">{category?.durationOfEpisodesWatched?.label ?? '—'}</p>
                            <p className="font-medium">{category?.durationOfEpisodesWatched?.value ?? '—'}</p>
                        </div>
                        <div>
                            <p className="text-sm text-gray-500">{category?.averageCompletionPercentage?.label ?? '—'}</p>
                            <p className="font-medium">{category?.averageCompletionPercentage?.value ?? '—'}</p>
                        </div>
                        <div>
                            <p className="text-sm text-gray-500">{category?.averageScrollDepth?.label ?? '—'}</p>
                            <p className="font-medium">{category?.averageScrollDepth?.value ?? '—'}</p>
                        </div>

                        <div>
                            <p className="text-sm text-gray-500">{category?.returnVisits7Day?.label ?? '—'}</p>
                            <p className="font-medium">{category?.returnVisits7Day?.value ?? '—'}</p>
                        </div>
                        <div>
                            <p className="text-sm text-gray-500">{category?.returnVisits30Day?.label ?? '—'}</p>
                            <p className="font-medium">{category?.returnVisits30Day?.value ?? '—'}</p>
                        </div>
                    </div> */}

                    <table className="w-full border border-gray-300 border-collapse rounded-lg">
                        <tbody>
                            <tr>
                                <td className="px-4 py-3 text-sm text-gray-500 border border-gray-300 dark:text-white">
                                    {category?.numberOfViews?.label ?? '—'}
                                </td>
                                <td className="px-4 py-3 font-medium border border-gray-300">
                                    {category?.numberOfViews?.value ?? '—'}
                                </td>
                            </tr>

                            <tr>
                                <td className="px-4 py-3 text-sm text-gray-500 border border-gray-300 dark:text-white">
                                    {category?.numberOfEpisodesWatched?.label ?? '—'}
                                </td>
                                <td className="px-4 py-3 font-medium border border-gray-300">
                                    {category?.numberOfEpisodesWatched?.value ?? '—'}
                                </td>
                            </tr>

                            {/* Duration intentionally excluded as per original code */}

                            <tr>
                                <td className="px-4 py-3 text-sm text-gray-500 border border-gray-300 dark:text-white">
                                    {category?.averageCompletionPercentage?.label ?? '—'}
                                </td>
                                <td className="px-4 py-3 font-medium border border-gray-300">
                                    {category?.averageCompletionPercentage?.value ?? '—'}
                                </td>
                            </tr>

                            <tr>
                                <td className="px-4 py-3 text-sm text-gray-500 border border-gray-300 dark:text-white">
                                    {category?.averageScrollDepth?.label ?? '—'}
                                </td>
                                <td className="px-4 py-3 font-medium border border-gray-300">
                                    {category?.averageScrollDepth?.value ?? '—'}
                                </td>
                            </tr>

                            <tr>
                                <td className="px-4 py-3 text-sm text-gray-500 border border-gray-300 dark:text-white">
                                    {category?.returnVisits7Day?.label ?? '—'}
                                </td>
                                <td className="px-4 py-3 font-medium border border-gray-300">
                                    {category?.returnVisits7Day?.value ?? '—'}
                                </td>
                            </tr>

                            <tr>
                                <td className="px-4 py-3 text-sm text-gray-500 border border-gray-300 dark:text-white">
                                    {category?.returnVisits30Day?.label ?? '—'}
                                </td>
                                <td className="px-4 py-3 font-medium border border-gray-300">
                                    {category?.returnVisits30Day?.value ?? '—'}
                                </td>
                            </tr>
                        </tbody>
                    </table>



                </div>

                {/* ===========================
          EPISODES SECTION
      =========================== */}
                {/* Episodes (selected in Create Show) */}
                {/* Episodes Section */}
                <div className="flex justify-end pt-4">
                    <button
                        onClick={() => setIsOpen(false)}
                        className="px-4 py-2 rounded bg-gray-300 dark:bg-slate-700 text-gray-800 dark:text-slate-200
"
                    >
                        Close
                    </button>
                </div>
            </div>
        </DialogWrapper>
    )
}

export default ViewCategoryDialog
